import React, { useState, useEffect, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import UserProgressContext from "../../userProgressContext";
import SoundManager from "../../services/SoundManager";

const Slideshow = ({ slides }) => {
  const { audioMuted, setNextButtonLocked } = useContext(UserProgressContext);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visitedSlides, setVisitedSlides] = useState(new Set([0]));

  useEffect(() => {
    setVisitedSlides(
      (prevVisitedSlides) => new Set(prevVisitedSlides.add(currentIndex))
    );
  }, [currentIndex]);

  useEffect(() => {
    const allVisited = visitedSlides.size >= slides.length;
    setNextButtonLocked(!allVisited);
    return () => setNextButtonLocked(false);
  }, [visitedSlides, slides.length]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleNext = () => {
    SoundManager.playSfx('slide-switch-sound');
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const handlePrev = () => {
    SoundManager.playSfx('slide-switch-sound');
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + slides.length) % slides.length
    );
  };

  return (
    <div className="p-0 md:p-4 relative flex flex-col items-center justify-center gap-2 mx-auto w-full h-full">
      {/* <button
        className="z-1 hover:text-indigo-500 text-indigo-300 text-7xl cursor-pointer"
        onClick={handlePrev}
      >
        &#8592;
      </button> */}

      <div className="flex flex-col h-full w-full md:w-[80%] border border-solid border-indigo-500 rounded-lg bg-white text-slate-700">
        {slides[currentIndex]["img"] && (
          <div className="flex h-[90%] md:h-72">
            <img
              src={require(`../../static/images/visuals/${slides[currentIndex]["img"]}.png`)}
              alt="Computer Screen"
              className="w-full object-contain"
            />
          </div>
        )}
        {slides[currentIndex]["header"] && (
          <h1 className="font-bold px-4 mt-2 text-lg md:text-xl">
            {slides[currentIndex]["header"]}
          </h1>
        )}
        <div className="h-full px-4 mt-2 mb-4 text-lg md:text-xl rounded-b-lg">
          {typeof slides[currentIndex]["content"] === "string" ? (
            <p>{slides[currentIndex]["content"]}</p>
          ) : (
            <ul className="list-disc px-4">
              {slides[currentIndex]["content"].map((item, id) => (
                <li key={id} className="mb-2">
                  {item}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      {/* <button
        className="z-1 border border-indigo-500 rounded-lg hover:bg-indigo-300 text-white text-2xl p-4 cursor-pointer"
        onClick={handleNext}
      >
        &#8594;
      </button> */}

      <div className="flex justify-between items-center w-full md:w-[80%]">
        <FontAwesomeIcon
          className={`z-1 w-8 h-8 text-white hover:text-indigo-300 cursor-pointer transition-all ease-in delay-100`}
          icon={faArrowLeft}
          onClick={handlePrev}
        />
        <p>
          Slide {currentIndex + 1} of {slides.length}
        </p>
        <FontAwesomeIcon
          className={`z-1 w-8 h-8 text-white hover:text-indigo-300 cursor-pointer transition-all ease-in delay-100`}
          icon={faArrowRight}
          onClick={handleNext}
        />
      </div>
    </div>
  );
};

export default Slideshow;
